import NewPasswordFormikForm from '../../components/authentication/NewPasswordFormikForm'
import { connect } from 'react-redux'
import { IChangePasswordObj, IStoreState } from '../../types'
import { RouteComponentProps } from 'react-router'
import { changePassword, checkToken } from '../../state/actions/auth/'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<{ token: string }>) {
  return {
    ...ownProps,
    ...state.authorization
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    handleSubmit: (ChangePasswordObj: IChangePasswordObj) => dispatch(changePassword(ChangePasswordObj)),
    handleCheckToken: (token: string) => dispatch(checkToken(token))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewPasswordFormikForm)



// WEBPACK FOOTER //
// ./src/containers/auth/NewPasswordFormikForm.ts